"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _Header = _interopRequireDefault(require("./Header.scss"));

var _moment = _interopRequireDefault(require("moment"));
/**
 * The head rests atop the calendar and deals with month changes and
 * displays month and year information.
 */


var Header = function Header(props) {
  //Move the date back a year
  var leftArrowClick = function leftArrowClick() {
    var date = props.value;
    date.month(date.month() - 1);
    props.onClick(date);
  }; //Move the date forward a year


  var rightArrowClick = function rightArrowClick() {
    var date = props.value;
    date.month(date.month() + 1);
    props.onClick(date);
  };

  var date = props.value;
  var month = date.month();
  var year = date.year();
  return _react.default.createElement("div", {
    className: _Header.default.header
  }, _react.default.createElement(_CwImage.default, {
    src: props.leftArrow,
    onClick: leftArrowClick,
    height: 16,
    width: 16
  }), _react.default.createElement("label", {
    className: _Header.default.monthYear
  }, props.monthName[month], " ", year), _react.default.createElement(_CwImage.default, {
    src: props.rightArrow,
    onClick: rightArrowClick,
    height: 16,
    width: 16
  }));
};

Header.propTypes = {
  /**
   * A working instance of a moment Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
   */
  value: _propTypes.default.instanceOf(_moment.default),

  /**
   * An array of localized months
   */
  monthName: _propTypes.default.array,

  /**
   * url for the left arrow image
   */
  leftArrow: _propTypes.default.string,

  /**
   * url for the right arrow image
   */
  rightArrow: _propTypes.default.string,

  /**
   * A function responsible for handling the arrow clicks in the header
   */
  onClick: _propTypes.default.func
};
Header.defaultProps = {
  monthName: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var _default = Header;
exports.default = _default;